import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import {
  determineHelpResource
} from './utilities';

import helpDrawerIconString from 'assets/images/help-drawer-icon.svg?raw';

import closeIconString from 'assets/images/dialog-close-button-icon.svg?raw';

import './index.scss';

const closeIcon = stringToSVG(closeIconString);
const helpDrawerIcon = stringToSVG(helpDrawerIconString);

const pageHelpResourceMap = {
  '/welcome': 'https://venturz.co/help-center',
  '/pages': 'https://venturz.co/help-center/website-builder',
  '/databases': 'https://venturz.co/help-center/databases',
  '/products': 'https://venturz.co/help-center/products',
  '/finance': 'https://venturz.co/help-center/finance',
  '/contacts': 'https://venturz.co/help-center/crm',
  '/inbox': 'https://venturz.co/help-center/inbox',
  '/community': 'https://venturz.co/help-center/community',
  '/campaigns': 'https://venturz.co/help-center/campaigns',
  '/tasks': 'https://venturz.co/help-center/tasks',
  '/analytics': 'https://venturz.co/help-center/analytics'
};

class HelpDrawer {

  constructor() {

    this.panel = null;
    this.isVisible = false;
    this.currentResource = null;

    this.el = el('x-tooltip', {
      text: 'Help resource',
      position: 'left'
    }, el('button#help-drawer-main', {
      onclick: (event) => this.handleClick(event)
    }, [
      helpDrawerIcon.cloneNode(true)
    ]));

  }

  showPanel() {

    if (this.isVisible) {
      return;
    }

    const helpResource = determineHelpResource(window.location.href, pageHelpResourceMap);

    if (helpResource !== this.currentResource) {
      this.currentResource = helpResource;

      const spinner = el('ht-spinner', { size: 'tiny' });
      const iframe = el('iframe', {
        src: helpResource,
        onload: () => {
          spinner.style.display = 'none';
          iframe.style.display = 'block';
        }
      });

      iframe.style.display = 'none';

      this.panel = el('#help-resource-view', [
        spinner,
        iframe,
        el('button#help-resource-close', {
          onclick: (event) => this.handleClose(),
          type: 'button',
          class: 'application-button round-button'
        }, [closeIcon.cloneNode(true)])
      ]);
    }

    mount(document.getElementById('startup-view-extras-container'), this.panel);

    setTimeout(() => {
      this.panel.classList.add('show');
    }, 10);

    this.isVisible = true;

  }

  hidePanel() {

    if (!this.isVisible) {
      return;
    }

    this.panel.classList.remove('show');
    this.panel.classList.add('hide');

    setTimeout(() => {
      unmount(document.getElementById('startup-view-extras-container'), this.panel);
      this.panel.classList.remove('hide');
      this.isVisible = false;
    }, 300);

  }

  handleClose() {

    this.hidePanel();
    this.outsideEventRegistration.cancel();

  }

  handleClick(event) {

    event.stopPropagation();
    event.preventDefault();

    this.showPanel();
    this.outsideEventRegistration = new OutsideClickEventRegistration(this.panel, () => this.handleClose());

  }

}

export default HelpDrawer;